import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';
import { AppSnackComponent } from '../../app/shared/app-snack/app-snack.component';

@Injectable()
export class AppMessagingService {
  constructor(private matSnackBar: MatSnackBar) {}

  public openSnack(message: string): MatSnackBarRef<AppSnackComponent> {
    return this.matSnackBar.openFromComponent(AppSnackComponent, {
      data: {
        message: message,
        action: 'Dismiss'
      },
      verticalPosition: 'top',
      duration: 5000,
      panelClass: 'message-snack-bar'
    });
  }
}
